import dayjs from 'dayjs'
import { isEmpty } from 'lodash'

import { getConfigValue, getSingleAdmin } from 'api'
import constants from 'app/constants'
import { confirm, getLoggedInUserId } from 'app/helpers'
import { dispatchLogoutStart } from 'app/store/dispatcher'
import { sentryLogger } from 'sentry'

const incorrectAccountLoginFunc = () => {
  dispatchLogoutStart()
}

const incorrectAccountCancelFunc = () => {
  window.location.href = window.location.origin
}

export const fetchAdmin = async (setUserError, setCentre) => {
  try {
    const queries = {
      id: getLoggedInUserId()
    }
    const response = await getSingleAdmin(queries)

    if (response?.centres?.length === 0) {
      setUserError(true)
      confirm(
        incorrectAccountLoginFunc,
        'Please login with a number registered to this centre in order to proceed.',
        incorrectAccountCancelFunc,
        {
          title: 'account not mapped to this centre',
          allowOutsideClick: false,
          confirmButtonText: 'Login now',
          cancelButtonText: 'cancel',
          backdrop: 'rgba(0,0,0,0.95)'
        }
      )
    } else {
      setCentre(response?.centres?.[0]?.uuid)
    }
    return response.data
  } catch (error) {
    sentryLogger(error, 'Error in fetching admin')
    throw error
  }
}

export const fetchPurposeOfVisitOptions = async (setOptions) => {
  try {
    const queries = {
      key: 'PARENT_VISIT_PURPOSE_CHOICES',
      app_name: 'alfred'
    }
    const response = await getConfigValue(queries)
    setOptions(response)
  } catch (error) {
    sentryLogger(error, 'Error in fetching purpose of visit options')
    throw error
  }
}

export const fetchAttributionOptions = async (setOptions) => {
  try {
    const queries = {
      key: 'PARENT_AWARENESS_SOURCE_CHOICES',
      app_name: 'alfred'
    }
    const response = await getConfigValue(queries)
    setOptions(response)
  } catch (error) {
    sentryLogger(error, 'Error in fetching attribution options')
    throw error
  }
}
